import { connect } from "react-redux";
import { compose } from "recompose";
import { getDevicesToPair } from "src/modules/device/duck/selectors";
import { openWizard } from "src/modules/pairing/duck/actions";
import { getInitialStep } from "src/modules/pairing/duck/selectors";
import { withFrame } from "src/components/Frame/Context";
import Welcome from "./Welcome";

function mapStateToProps(state) {
  return {
    hasDevices: getDevicesToPair(state)?.length > 0,
    initialStep: getInitialStep(state)
  };
}

const enhance = compose(
  withFrame,
  connect(mapStateToProps, {
    openWizard: (initialStep = "nearby-devices") =>
      openWizard({
        initialStep
      })
  })
);

export default enhance(Welcome);
